import { ProgressBarContainer, ProgressBarFill, ProgressBarTrack, ProgressPercentage } from "./StyledComponents";

interface OnboardingProgressBarProps {
    progress: number;
}

export const OnboardingProgressBar = (props: OnboardingProgressBarProps) => {
    return (
        <ProgressBarContainer
            role="progressbar"
            aria-valuemin={0}
            aria-valuemax={100}
            aria-valuenow={Math.round(props.progress)}
        >
            <ProgressPercentage>{Math.round(props.progress)}%</ProgressPercentage>
            <ProgressBarTrack>
                <ProgressBarFill progress={props.progress} />
            </ProgressBarTrack>
        </ProgressBarContainer>
    );
};
